<template>
  <div class="tw-shadow">
    <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0" v-if="ready">
      <b-tabs card fill>
        <b-tab v-for="(tab, key) in data" :title="key" :key="key" :active="key === defaultSelected">

          <h6 class="tw-font-bolder tw-mb-0">Positive Infections </h6>
          <!-- <span class="text-secondary tw-text-xs">{{ tab.chartdata.datasets[0].data[0] }} Infected in total</span> -->
          <p class="text-secondary tw-text-xs">{{ tab.chartdata.datasets[0].data[0] }} Total infections</p>
          <doughnut-chart class="k-test" :chartdata="tab.chartdata" :options="tab.options"></doughnut-chart>
          <div id="enrollment-label" style="margin-top: 0em">
            <h1 class="tw-text-4xl tw-font-bolder text-center tw-mb-0">{{ tab.chartdata.datasets[0].data[0] }}</h1>
            <h5 class="tw-font-bolder text-center">Total infections</h5>
          </div>

          <div class="text-right">
            <b-button :to="{ name: 'metrics-subject-infected-details'}" variant="outline-secondary">More</b-button>
          </div>
        </b-tab>
      </b-tabs>
      <div class="tw-mt-auto tw-flex tw-justify-end">
        <info-popover>
          <template v-slot:title>Positive Infections</template>
          <p>RDT result is positive</p>
        </info-popover>
      </div>
    </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DoughnutChart from "@/components/charts/DoughnutChart.vue";

import * as _ from 'lodash';

export default {
  mixins: [],
  components: {
    DoughnutChart
  },
  props: {},
  data: function() {
    return {
      ready: false,
      chartdata: {
        datasets: [],
        labels: ["Infected"]
      },
      defaultSelected: "Cohort",
      options: {
        responsive: true,
        maintainAspectRatio: true,
        cutoutPercentage: 65,
        circumference: Math.PI,
        rotation: -Math.PI,
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 18
          }
        },
        title: {
          display: false,
          text: "Enrolled Subjects"
        },
        tooltips: {
          bodyFontSize: 14
        },
        animation: {
          animateScale: true,
          animateRotate: true
        }
      },
      data: {}
    };
  },
  mounted: function() {
    this.get();
  },
  methods: {
    get: function() {
      const that = this;

      const params = {};

      HTTP.get("/uganda/metrics/positive-infections-chart/", { params: params })
        .then((response) => {

        const chartData = {"Cohort": [
          response.data.total_infections,
        ]}

        _.each(chartData, (val, key) => {
          that.data[key] = {
            id: key.replace(' ', '-'),
            chartdata: _.cloneDeep(that.chartdata),
            options: _.cloneDeep(that.options)
          };

          // Get the number of Current Subjects Enrolled
          val[1] -= val[0]

          that.data[key].chartdata.datasets.push(
            {
                data: val,
                backgroundColor: ["#37B1CA", "#eee"]
            }
          );
        });

        that.ready = true;

      }).catch((error) => {
          HandleErrors.HandleErrors(error);
      });
    },
    percentRetained: function(chartdata) {
      let val = _.round((chartdata.datasets[0].data[0] / (chartdata.datasets[0].data[0] + chartdata.datasets[0].data[1])) * 100, 2);
      return _.isNaN(val) ? 0 : val;
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {}
  }
};
</script>

<style>
#enrollment-label {
  position: absolute;
  top: 68%;
  left: 50%;
  transform: translate(-50%, -50%);
}
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 .5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: .35rem .5rem;
}
</style>